export const GOAL_DIMENSION_EMPTY_VALUE = '' // 本来はNULLを使いたいが、NULLにするとユニーク制約が使えないので、空文字とする
export const GOAL_RECORDS_MAX_SIZE = 10 ** 8 // csvインポートの最大レコード数。 XXX: 適切な数値は未検討
export const GOAL_MODEL_NAME = 'salescore_pivoted_goal'
